import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const ACCOUNT_THEMES = ['default', 'whatsapp', 'dark'];

export const setAccountTheme = theme => {
  // Remove all theme classes
  ACCOUNT_THEMES.forEach(t => {
    document.body.classList.remove(`theme-${t}`);
  });
  if (theme && theme !== 'default') {
    document.body.classList.add(`theme-${theme}`);
  }
  // If whatsapp theme, force dark color scheme on conversation area
  if (theme === 'dark') {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  }
};
